export default function paymentMethod(state = null, action) {
  if (action.type === 'SET_PAYMENT_METHOD') {
    return action.payload || state
  }

  if (action.type === 'RECEIVE_INITIAL_SESSION') {
    if (action.payload.previous_payment_method) {
      return action.payload.previous_payment_method
    }
  }

  return state
}
